import * as React from 'react';

import ArrowBoxRight16 from './ArrowBoxRight16';

export const arrowBoxRight16 = () => <ArrowBoxRight16 />;

export default {
    title: 'Icon|Line|ArrowBoxRight16',
    component: ArrowBoxRight16,
    parameters: {
        notes: "`import ArrowBoxRight16 from 'box-ui-elements/es/icon/line/ArrowBoxRight16';`",
    },
};
